<template>
  <div>
    <header-component />
  </div>
  <div v-if="isInitError" id="com_form_contet1">
    <div class="errorform">
      <!-- エラーメッセージの表示エリア -->
      <div v-if="apiErrorMessage" class="error-message">
        {{ apiErrorMessage }}
      </div>
    </div>
  </div>
  <loading-overlay v-model:active="isLoading" :is-full-page="true" />
  <div v-if="isDataFetched" class="com_page_title1">
    <div class="com_inner1 clearfix">
      <div class="block1">
        <img
          src="@/assets/common/img/skilup-top_title.png"
          alt=""
          class="image1"
        />
      </div>
    </div>
  </div>
  <div v-if="isDataFetched" id="contents1">
    <section class="com_sec1">
      <div class="com_inner1 clearfix">
        <div class="com_l_banner1">
          <router-link to="/skilup-toranomaki">
            <img
              src="/WITH_AG_PORTAL/images/k042_td_20250516_agent_insight_bnr_toranoaki_w860.png"
              alt=""
              class="banner1"
            />
          </router-link>
        </div>
        <div class="com_contents2">
          <div class="main_column1">
            <!-- エラーメッセージの表示エリア -->
            <div v-if="apiErrorMessage" class="error-message">
              {{ apiErrorMessage }}
            </div>
            <!-- 初期表示エリア -->
            <div v-if="!isSerched">
              <p class="text1">
                <span>スキルアップ動画一覧</span>
              </p>
              <!-- 新着動画リストタイトル -->
              <div class="com_i_title1 a">
                <div>
                  <img
                    src="/WITH_AG_PORTAL/images/icon-t-movie2.png"
                    alt=""
                    class="icon-t-movie"
                  />
                  <h2>新着動画</h2>
                </div>
              </div>
              <!-- 新着動画リスト -->
              <div class="com_thumb_list1 com_more2">
                <router-link
                  v-for="item in getDisplayedNewVideo(
                    videoList,
                    isNewVideoOpen
                  )"
                  :key="item.contentsId"
                  class="item1"
                  :to="`/${item.detailPath}/categoryId/${item.categoryId}/contentsId/${item.contentsId}`"
                >
                  <div>
                    <div class="thumb1 a">
                      <img
                        v-if="item.thumbnailPath && item.thumbnailName"
                        :src="
                          `/${item.thumbnailPath}/${item.thumbnailName}` +
                          '?v=' +
                          new Date().getTime()
                        "
                        alt=""
                        @error="handleImageError(item)"
                      />
                    </div>
                  </div>
                  <div>
                    <div class="meta1">
                      <span v-if="item.isWatched" class="com_tag3">視聴済</span>
                      <span v-else class="com_tag4">未視聴</span>
                      <span class="com_tag2">{{ item.phaseName }}</span>
                      <div v-if="isKaunetAdmin" class="edit1">
                        <a
                          href="#"
                          @click.prevent="
                            editContents(
                              item.categoryId,
                              item.contentsId,
                              item.updateFormPath
                            )
                          "
                          class="com_edit1"
                          ><span></span
                        ></a>
                      </div>
                    </div>
                    <div class="body1">
                      <h2>
                        <p class="com_link1">
                          {{ item.videoTitle }}
                        </p>
                      </h2>
                      <p>
                        {{ item.videoCaption }}
                      </p>
                    </div>
                  </div>
                </router-link>

                <div
                  v-if="newVideoListLength > newVideoDefaultDispCnt"
                  :class="{ open1: isNewVideoOpen }"
                >
                  <span class="more_button1" @click="toggleNewVideoOpen()"
                    ><span>もっと見る</span></span
                  >
                </div>
              </div>
              <!-- 動画一覧 -->
              <div
                v-for="phase in phaseListData"
                :key="`${phase.categoryId}-${phase.phaseId}`"
              >
                <div class="com_i_title1 a com_mgt45">
                  <div>
                    <img
                      :src="
                        `/WITH_AG_PORTAL/images/${phase.iconFileName}` +
                        '?v=' +
                        new Date().getTime()
                      "
                      alt=""
                      class="icon-t-movie"
                    />
                    <h2>{{ phase.phaseName }}</h2>
                  </div>
                </div>
                <div class="com_thumb_list1 com_more2">
                  <router-link
                    v-for="capter in getContentsByPhase(
                      phase.categoryId,
                      phase.phaseId,
                      phase.isOpen
                    )"
                    :key="capter.categoryId + capter.contentsId"
                    class="item1"
                    :to="`/${capter.detailPath}/categoryId/${capter.categoryId}/contentsId/${capter.contentsId}`"
                  >
                    <div class="thumb1 a">
                      <img
                        :src="
                          `/${capter.thumbnailPath}/${capter.thumbnailName}` +
                          '?v=' +
                          new Date().getTime()
                        "
                        alt=""
                        @error="handleImageError(capter)"
                      />
                    </div>
                    <div>
                      <div class="meta1">
                        <span v-if="capter.isWatched" class="com_tag3"
                          >視聴済</span
                        >
                        <span v-else class="com_tag4">未視聴</span>
                        <div v-if="isKaunetAdmin" class="edit1">
                          <a
                            href="#"
                            @click.prevent="
                              editContents(
                                capter.categoryId,
                                capter.contentsId,
                                capter.updateFormPath
                              )
                            "
                            class="com_edit1"
                            ><span></span
                          ></a>
                        </div>
                      </div>
                      <div class="body1">
                        <h2>
                          <p class="com_link1">
                            {{ capter.videoTitle }}
                          </p>
                        </h2>
                        <p>
                          {{ capter.videoCaption }}
                        </p>
                      </div>
                    </div>
                  </router-link>
                  <div
                    v-if="
                      getContentsByPhaseLength(
                        phase.categoryId,
                        phase.phaseId
                      ) > defaultDispCnt
                    "
                    :class="{ open1: phase.isOpen }"
                  >
                    <span
                      class="more_button1"
                      @click="togglePhaseVideoOpen(phase)"
                      ><span>もっと見る</span></span
                    >
                  </div>
                </div>
              </div>
            </div>
            <!-- 絞込検索後エリア -->
            <div v-else>
              <div class="com_search_result_hd1">
                <div>
                  <p class="text1">
                    <span>{{ dispKeyWord }}</span
                    >{{ dispTitle }}
                  </p>
                </div>
              </div>
              <div class="com_thumb_list1 com_more2">
                <router-link
                  v-for="item in paginatedData"
                  :key="item.categoryId + item.contentsId"
                  class="item1"
                  :to="`/${item.detailPath}/categoryId/${item.categoryId}/contentsId/${item.contentsId}`"
                >
                  <div>
                    <div class="thumb1 a">
                      <img
                        v-if="item.thumbnailPath && item.thumbnailName"
                        :src="
                          `/${item.thumbnailPath}/${item.thumbnailName}` +
                          '?v=' +
                          new Date().getTime()
                        "
                        alt=""
                        @error="handleImageError(item)"
                      />
                    </div>
                  </div>
                  <div>
                    <div class="meta1">
                      <span v-if="item.isWatched" class="com_tag3">視聴済</span>
                      <span v-else class="com_tag4">未視聴</span>
                      <span class="com_tag2">{{ item.phaseName }}</span>
                      <div v-if="isKaunetAdmin" class="edit1">
                        <a
                          href="#"
                          @click.prevent="
                            editContents(
                              item.categoryId,
                              item.contentsId,
                              item.updateFormPath
                            )
                          "
                          class="com_edit1"
                          ><span></span
                        ></a>
                      </div>
                    </div>
                    <div class="body1">
                      <h2>
                        <p class="com_link1">
                          {{ item.videoTitle }}
                        </p>
                      </h2>
                      <p>
                        {{ item.videoCaption }}
                      </p>
                    </div>
                  </div>
                </router-link>
              </div>

              <content-pagination
                :current-page="currentPage"
                :total-pages="totalPages"
                :items-per-page="itemsPerPage"
                @page-changed="handlePageChange"
              />
            </div>
          </div>
          <div class="side_search_option1">
            <div v-if="isSerched">
              <button type="button" class="button1" @click="backInitDisp">
                初期表示に戻す
              </button>
              <hr />
            </div>

            <h2 class="title1">
              <span class="com_icon_option1"></span>絞り込み検索
            </h2>

            <div class="block_search1">
              <h3 class="title2">キーワードから探す</h3>
              <div>
                <input
                  type="text"
                  name=""
                  placeholder="キーワードを入力"
                  @keyup.enter="narrowSearch"
                  v-model="narrowKeyword"
                  maxlength="50"
                />
                <button type="button" name="" @click="narrowSearch"></button>
              </div>
            </div>
            <!-- エラーメッセージの表示エリア -->
            <div v-if="errorMessage" class="error-message">
              {{ errorMessage }}
            </div>
            <div class="block_options_group1">
              <label class="com_checkbox1"
                ><input
                  type="checkbox"
                  name=""
                  v-model="isUnWatchedOnly"
                /><span class="t1 com_fs14">未視聴の動画のみ表示</span></label
              >
              <label v-if="isKaunetAdmin" class="com_checkbox1"
                ><input
                  type="checkbox"
                  name=""
                  v-model="isOutsidePostPeriod"
                /><span class="t1 com_fs14">掲載期間外も表示する</span></label
              >
              <button type="button" class="button1" @click="narrowSearch">
                検索
              </button>
            </div>
            <div class="block_options_group1">
              <div class="com_center1 com_mgb10">
                <a
                  href="javascript:void(0)"
                  class="option_uncheck_all1 com_link1"
                  @click="uncheckAll"
                >
                  <span class="com_icon_cross1"></span>チェックを外す
                </a>
              </div>
              <h3 class="title2">カテゴリーから探す</h3>
              <div
                v-for="(group, index) in groupedTags"
                :key="index"
                class="option_group1"
              >
                <div class="hd1">
                  <label class="com_checkbox1">
                    <input
                      type="checkbox"
                      v-model="group.isPhaseChecked"
                      @change="togglePhase(group)"
                    />
                    <span class="t1">{{ group.phaseName }}</span>
                  </label>
                </div>
                <div class="body1">
                  <label
                    v-for="(tag, idx) in group.tags"
                    :key="idx"
                    class="com_checkbox1"
                  >
                    <input
                      type="checkbox"
                      v-model="tag.isChecked"
                      @change="checkPhaseStatus(group, tag)"
                    />
                    <span class="t2">{{ tag.tagName }}</span>
                  </label>
                </div>
              </div>
              <hr />
              <button type="button" class="button1" @click="narrowSearch">
                検索
              </button>
              <div class="com_center1 com_mgt5">
                <a
                  href="javascript:void(0)"
                  class="option_uncheck_all1 com_link1"
                  @click="uncheckAll"
                  ><span class="com_icon_cross1"></span>チェックを外す</a
                >
              </div>
            </div>
          </div>
          <!-- サイドバナー -->
          <div class="side_right1">
            <SkilupSideSliderComponent />
          </div>
        </div>
      </div>
    </section>
  </div>
  <div v-if="isDataFetched">
    <!-- フッタ -->
    <FooterComponent />
  </div>

  <BackToTop />
</template>

<script lang="ts">
import { defineComponent, onMounted, ref, computed } from "vue";
import apiAuthClient from "@/util/apiClientAuth";
import {
  outputDebugLogs,
  formatMessage,
  getTargetDate,
  scrollToTop,
  sanitizeInput,
  isTokenAlive,
  trimKeyword,
} from "@/Common";
import { AxiosError } from "axios";
import messages from "@/assets/messages.json";
import { AppConstants } from "@/constants/AppConstants";
import BackToTop from "../controls/BackToTop.vue";
import { useProcessingStore } from "../../store/useProcessingStore";
import HeaderComponent from "../layout/HeaderComponent.vue";
import FooterComponent from "../layout/FooterComponent.vue";
import SkilupSideSliderComponent from "../layout/SkilupSideSliderComponent.vue";
import { useUserStore } from "@/store/userStore";
import { useRouter } from "vue-router";
import ContentPagination from "../controls/ContentPagination.vue";
import LoadingOverlay from "vue-loading-overlay";
import "vue-loading-overlay/dist/css/index.css";

interface TagItem {
  categoryId: string;
  phaseId: string;
  phaseName: string;
  tagId: string;
  tagName: string;
  isChecked: boolean;
}

interface PhaseGroup {
  categoryId: string;
  phaseId: string;
  phaseName: string;
  tags: TagItem[];
  isPhaseChecked: boolean;
}

interface PhaseItem {
  categoryId: string;
  phaseId: string;
  phaseName: string;
  iconFileName: string;
  isOpen: boolean;
}

interface VideoItem {
  phaseId: string;
  phaseName: string;
  categoryId: string;
  skilupId: string;
  contentsId: string;
  thumbnailPath: string;
  thumbnailName: string;
  videoTitle: string;
  videoCaption: string;
  isNewVideo: boolean;
  isWatched: boolean;
  postPeriod: Date;
  displayOrder: number;
  updateDate: number;
  detailPath: string;
  updateFormPath: string;
}

export default defineComponent({
  name: "SkilupTopComponent",
  components: {
    HeaderComponent,
    FooterComponent,
    BackToTop,
    SkilupSideSliderComponent,
    ContentPagination,
    LoadingOverlay,
  },
  setup() {
    const router = useRouter();
    const isInitError = ref(true); // 初期表示時のエラーフラグ
    const processingStore = useProcessingStore();
    const isSerched = ref(false); // 絞込済かのフラグ
    const narrowKeyword = ref(""); // 絞込キーワード
    const tagListData = ref<TagItem[]>([]); // タグデータ
    const phaseListData = ref<PhaseItem[]>([]); // フェーズリスト
    const isDataFetched = ref(false); // データが取得済みかどうかを追跡
    const errorMessage = ref(""); // エラーメッセージ（キーワード検索の下のやつ）
    const apiErrorMessage = ref(""); // エラーメッセージ（ページの真ん中にでるやつ）
    const videoList = ref<VideoItem[]>([]); // 動画一覧データ
    const narrowVideoList = ref<VideoItem[]>([]); // 絞込後の動画一覧データ
    const isNewVideoOpen = ref(false); // 新着動画のアコーディオン表示状態
    const newVideoDefaultDispCnt = ref(3);
    const defaultDispCnt = ref(3);
    const agCode = ref(""); // AGコード
    const userId = ref(""); // ユーザーID
    const pseudoAgCode = ref(""); // 疑似ログインAGコード
    const pseudoUserId = ref(""); // 疑似ログインユーザーID
    const isKaunetAdmin = ref(false); // カウネット管理者フラグ
    const serchAgCode = ref(""); // 検索用AGコード
    const serchUserId = ref(""); // 検索用ユーザーID
    const { logoutUser } = useUserStore();
    const currentPage = ref(1); // 現在ページ
    const itemsPerPage = ref(10); // 1ページに表示する最大件数
    const dispTitle = ref(""); // 表示タイトル
    const dispKeyWord = ref(""); // 表示切キーワード
    const isUnWatchedOnly = ref(false); // 未視聴のみ表示するフラグ
    const newVideoListLength = ref(0);
    const isOutsidePostPeriod = ref(false); // 掲載期間外も表示する
    const isLoading = ref(false);

    // 初期処理
    onMounted(async () => {
      // 処理中フラグON
      processingStore.isProcessing = true;
      isLoading.value = true;

      try {
        // 初期処理時はTrue
        isInitError.value = true;

        // ローカルストレージからユーザー情報を取得して内部変数に展開
        const userInfo = localStorage.getItem(AppConstants.USER_SESSION_NAME);

        if (userInfo) {
          const parsedUserInfo = JSON.parse(userInfo);
          agCode.value = parsedUserInfo.agCode;
          userId.value = parsedUserInfo.userId;
          pseudoAgCode.value = parsedUserInfo.pseudoAgCode;
          pseudoUserId.value = parsedUserInfo.pseudoUserId;
          isKaunetAdmin.value =
            parsedUserInfo.isKaunet && parsedUserInfo.isAdmin;

          if (pseudoUserId.value == "") {
            // 疑似ログインIDが空の場合は、疑似ログインしていないとみなす
            serchUserId.value = userId.value;
            serchAgCode.value = agCode.value;
          } else {
            outputDebugLogs("疑似ログイン状態");
            serchUserId.value = pseudoUserId.value;
            serchAgCode.value = pseudoAgCode.value;
          }

          outputDebugLogs("管理者フラグ：" + parsedUserInfo.isKaunet);
          outputDebugLogs("カウネットフラグ：" + parsedUserInfo.isAdmin);
          outputDebugLogs("カウネット管理者：" + isKaunetAdmin.value);
        }

        // 初期表示データ取得API
        const response = await apiAuthClient.post("/api/SkilUp/getVideoList", {
          systemKbn: AppConstants.SYSTEM_KBN_WITH,
          userId: serchUserId.value,
          agCode: serchAgCode.value,
          targetDate: getTargetDate(""),
        });

        // フェーズリストを取得
        phaseListData.value = response.data.phaseListData;
        // 動画一覧を取得
        videoList.value = response.data.videoListData;
        // タグ一覧を取得
        tagListData.value = response.data.skulupTagData;
        // 新着動画の表示件数を取得
        newVideoDefaultDispCnt.value = response.data.newVideoListDispNum;
        // 各フェーズの動画一覧の表示件数を取得
        defaultDispCnt.value = response.data.videoListDispNum;

        isSerched.value = false;
        isInitError.value = false;
        isDataFetched.value = true; // データが取得されたことを設定
      } finally {
        // 処理中フラグOFF
        processingStore.isProcessing = false;
        isLoading.value = false;
      }
    });

    //** 選択されているカテゴリIDとフェーズIDをハイフンで結合してカンマ区切りで取得します */
    const selectedPhaseIds = computed(() => {
      return groupedTags.value
        .filter((group) => group.isPhaseChecked)
        .map((group) => `${group.categoryId}-${group.phaseId}`)
        .join(",");
    });

    //** 選択されているタグIDをカンマ区切りで取得します */
    const selectedTagIds = computed(() => {
      return groupedTags.value
        .flatMap((group) => group.tags)
        .filter((tag) => tag.isChecked)
        .map((tag) => tag.tagId)
        .join(",");
    });

    /**
     * 絞込検索実行
     */
    const narrowSearch = async () => {
      // なにか処理中の場合は何もしない
      if (processingStore.isProcessing) {
        return;
      }

      // 処理中フラグON
      processingStore.isProcessing = true;

      try {
        // ------- for debug --------
        outputDebugLogs("絞込検索");
        outputDebugLogs("キーワード：" + narrowKeyword.value);
        outputDebugLogs("絞込フェーズ：" + selectedPhaseIds.value);
        outputDebugLogs("絞込タグ：" + selectedTagIds.value);
        // ------- for debug --------

        // エラーメッセージを初期化
        errorMessage.value = "";
        apiErrorMessage.value = "";

        // キーワードをサニタイジング
        const sanitizedKeyWord = trimKeyword(
          sanitizeInput(narrowKeyword.value, true)
        );

        // トークン有効性チェック
        if ((await isTokenAlive()) == false) {
          // トークンが無効な場合はログイン画面へ
          logoutUser();
          alert(messages.ERR_USER001);
          router.push("/login");
          return;
        }

        // 1文字の場合はNG
        if (sanitizedKeyWord.length == 1) {
          errorMessage.value = formatMessage(
            messages.ERR_0028,
            "キーワード",
            "2"
          );
          return;
        }

        // 動画一覧を取得
        const response = await apiAuthClient.post(
          "/api/SkilUp/narrowVideoList",
          {
            systemKbn: AppConstants.SYSTEM_KBN_WITH,
            userId: serchUserId.value,
            agCode: serchAgCode.value,
            targetDate: getTargetDate(""),
            narrowKeyword: sanitizedKeyWord,
            narrowTags: selectedTagIds.value,
            isOnlyUnWatched: isUnWatchedOnly.value,
            isOutsidePostPeriod: isOutsidePostPeriod.value,
          }
        );

        // 動画一覧を取得
        narrowVideoList.value = response.data.videoListData;
        // ページネーションの現在ページを1ページ目に
        currentPage.value = 1;

        if (sanitizedKeyWord) {
          dispKeyWord.value = "「" + sanitizedKeyWord + "」";
          dispTitle.value = "の検索結果:" + narrowVideoList.value.length + "件";
        } else {
          dispKeyWord.value = "";
          dispTitle.value = "検索結果:" + narrowVideoList.value.length + "件";
        }

        isSerched.value = true;
      } finally {
        // スクロールを一番上に戻す
        scrollToTop();
        processingStore.isProcessing = false;
      }
    };

    //** 初期状態に戻す */
    const backInitDisp = async () => {
      // なにか処理中の場合は何もしない
      if (processingStore.isProcessing) {
        return;
      }

      // 処理中フラグON
      processingStore.isProcessing = true;

      try {
        // 絞込キーワードをクリア
        narrowKeyword.value = "";
        // タグの選択状態を解除
        uncheckAll();
        // 未視聴の動画のみ表示のチェックをOFF
        isUnWatchedOnly.value = false;
        isOutsidePostPeriod.value = false;
        isSerched.value = false;

        // 各フェーズのアコーディオン表示を戻す
        clearAcOpen();

        // ページネーションの現在ページを1ページ目に
        currentPage.value = 1;

        isNewVideoOpen.value = false;
      } finally {
        // スクロールを一番上に戻す
        scrollToTop();
        processingStore.isProcessing = false;
      }
    };

    //** カテゴリIDのチェックON・OFFで紐づいているタグのチェックをON・OFFする */
    const togglePhase = (group: PhaseGroup) => {
      group.tags.forEach((tag) => {
        tag.isChecked = group.isPhaseChecked;
        toggleTag(tag);
      });
    };

    //** 同じタグIDのチェック状態を更新する */
    const toggleTag = (tag: TagItem) => {
      tagListData.value.forEach((item) => {
        if (item.tagId === tag.tagId) {
          item.isChecked = tag.isChecked;
        }
      });
    };

    //** カテゴリのチェック状態 */
    const checkPhaseStatus = (group: PhaseGroup, tag: TagItem) => {
      group.isPhaseChecked = group.tags.every((tag) => tag.isChecked);
      toggleTag(tag);
    };

    //** すべてのタグの選択状態を解除します */
    const uncheckAll = () => {
      groupedTags.value.forEach((group) => {
        group.isPhaseChecked = false;
        group.tags.forEach((tag) => {
          tag.isChecked = false;
        });
      });
    };

    /** フェーズIDでグループ化したタグのリスト */
    const groupedTags = computed(() => {
      const groups: PhaseGroup[] = [];
      const phaseMap: Record<string, PhaseGroup> = {};

      tagListData.value.forEach((item) => {
        const key = `${item.categoryId}-${item.phaseId}-${item.phaseName}`; // categoryIdとphaseIdの組み合わせでキーを生成
        if (!phaseMap[key]) {
          phaseMap[key] = {
            categoryId: item.categoryId,
            phaseId: item.phaseId,
            phaseName: item.phaseName,
            tags: [],
            isPhaseChecked: false,
          };
          groups.push(phaseMap[key]);
        }
        phaseMap[key].tags.push(item);
      });

      // Set initial category checked status based on tags
      groups.forEach((group) => {
        group.isPhaseChecked = group.tags.every((tag) => tag.isChecked);
      });

      return groups;
    });

    const clearAcOpen = () => {
      phaseListData.value.forEach((item) => {
        item.isOpen = false;
      });
    };

    /**
     * 新着動画のisOpenをトグルする関数
     * @param phase フェーズリスト
     */
    const toggleNewVideoOpen = () => {
      isNewVideoOpen.value = !isNewVideoOpen.value;
    };

    /**
     * 各フェーズのisOpenをトグルする関数
     * @param phase フェーズリスト
     */
    const togglePhaseVideoOpen = (phase: PhaseItem) => {
      phase.isOpen = !phase.isOpen;
    };

    /**
     * 表示する新着動画のリストを取得
     * @param videoList 動画一覧データ
     * @param isOpen アコーディオン展開状態
     */
    const getNewVideoList = (videoList: VideoItem[]) => {
      return computed(() => {
        const sortedNewVideoList = videoList
          .filter((video) => video.isNewVideo)
          .sort((a, b) => {
            // 未視聴のものを上位に配置
            if (a.isWatched !== b.isWatched) {
              return a.isWatched ? 1 : -1;
            }
            // 更新日時の降順
            if (a.updateDate > b.updateDate) return -1;
            if (a.updateDate < b.updateDate) return 1;
            // コンテンツIDの降順
            return a.contentsId > b.contentsId ? -1 : 1;
          });

        return sortedNewVideoList;
      });
    };

    const getDisplayedNewVideo = (videoList: VideoItem[], isOpen: boolean) => {
      const newVideoList = getNewVideoList(videoList);
      newVideoListLength.value = newVideoList.value.length;
      return isOpen
        ? newVideoList.value
        : newVideoList.value.slice(0, newVideoDefaultDispCnt.value);
    };

    /**  指定したフェーズIDのデータを取得します
     * @param catphaseIdegoryId - フェーズID
     * @param count - 取得する件数
     */
    const getContentsByPhase = (
      dispCategoryId: string,
      phaseId: string,
      isOpen: boolean
    ): VideoItem[] => {
      return isOpen
        ? videoList.value.filter(
            (item) =>
              item.skilupId === dispCategoryId && item.phaseId === phaseId
          )
        : videoList.value
            .filter(
              (item) =>
                item.skilupId === dispCategoryId && item.phaseId === phaseId
            )
            .slice(0, defaultDispCnt.value);
    };

    const getContentsByPhaseLength = (
      dispCategoryId: string,
      phaseId: string
    ): number => {
      return videoList.value.filter(
        (item) => item.skilupId === dispCategoryId && item.phaseId === phaseId
      ).length;
    };

    /**
     * サムネイルが無い時の処理
     * @param item 動画一覧の明細データ
     */
    const handleImageError = (item: VideoItem) => {
      outputDebugLogs("contentsId: " + item.contentsId);
      outputDebugLogs("thumbnailName: " + item.thumbnailName);

      item.thumbnailPath = "WITH_AG_PORTAL/images";
      item.thumbnailName = "no-image1.png";
    };

    //** ページネーションのデータ生成 */
    const paginatedData = computed(() => {
      const start = (currentPage.value - 1) * itemsPerPage.value;
      const end = start + itemsPerPage.value;
      return narrowVideoList.value.slice(start, end);
    });

    //** 頁総数を取得 */
    const totalPages = computed(() => {
      return Math.ceil(narrowVideoList.value.length / itemsPerPage.value);
    });

    //** ページ切替ハンドラ */
    const handlePageChange = (page: number) => {
      currentPage.value = page;
      // スクロールを一番上に戻す
      scrollToTop();
    };

    /**
     * コンテンツ編集
     * コンテンツ登録画面に編集モードで遷移します
     * @param ctgyId - カテゴリID
     * @param ctsId - コンテンツID
     */
    const editContents = (
      ctgyId: string,
      ctsId: string,
      updFormPath: string
    ) => {
      if (processingStore.isProcessing) {
        return;
      }
      processingStore.isProcessing = true;

      try {
        outputDebugLogs("カテゴリID: " + ctgyId);
        outputDebugLogs("コンテンツID: " + ctsId);

        // コンテンツ登録画面へ編集モードで遷移
        router.push({
          path: "/" + updFormPath,
          query: {
            categoryId: ctgyId,
            contentsId: ctsId,
            editMode: AppConstants.CONTENTS_EDIT_MODE_UPDATE,
          },
        });
      } finally {
        processingStore.isProcessing = false;
      }
    };

    return {
      isInitError,
      isSerched,
      narrowSearch,
      narrowKeyword,
      uncheckAll,
      groupedTags,
      togglePhase,
      checkPhaseStatus,
      phaseListData,
      isDataFetched,
      errorMessage,
      apiErrorMessage,
      videoList,
      isNewVideoOpen,
      toggleNewVideoOpen,
      getDisplayedNewVideo,
      getContentsByPhase,
      defaultDispCnt,
      newVideoDefaultDispCnt,
      handleImageError,
      backInitDisp,
      currentPage,
      itemsPerPage,
      narrowVideoList,
      paginatedData,
      totalPages,
      handlePageChange,
      dispKeyWord,
      dispTitle,
      isUnWatchedOnly,
      newVideoListLength,
      getContentsByPhaseLength,
      togglePhaseVideoOpen,
      isKaunetAdmin,
      isOutsidePostPeriod,
      editContents,
      isLoading,
    };
  },
});
</script>
